// biome-ignore-all lint/style/useNamingConvention: allow camel case

import type {Dispatch} from 'redux';
import urls from 'urls';
import {apiClient} from '~/api/api-client';
import {favoriteTemplate, initFavorites} from '~/GalleryPB/reducers/favorites';

type GetFavoritesResponse = {
  pm_templates: {template_id: string}[];
  templates: {template_id: string}[];
};

// Fetch the existing favorites for the logged-in user
export const fetchAllFavoritesThunk = async (dispatch: Dispatch) => {
  const response = await apiClient.get(urls.get('ajax_gallery_favorites'));
  const data: GetFavoritesResponse = await response.json();
  dispatch(
    initFavorites([
      ...data.pm_templates.map((t) => t.template_id),
      ...data.templates.map((t) => t.template_id),
    ])
  );
};

/**
 * Toggle the favorited status for a gallery template
 * @param identifier the identifier for the template
 * @param premium whether or not the template is a premium template
 * @param method "post" or "delete" this favorite
 */
export const favoriteTemplateThunk =
  (identifier: string, premium: boolean, method: 'post' | 'delete') =>
  async (dispatch: Dispatch) => {
    // Build the request
    const url = urls.get('ajax_gallery_favorites');
    const body = {
      template: identifier,
      plus: premium,
    };

    const headers: HeadersInit = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    };
    const csrftoken = evite.cookie('csrftoken');
    if (csrftoken) {
      headers['X-CSRFToken'] = csrftoken;
    }

    // Send the request
    fetch(url, {
      method: method.toUpperCase(),
      body: JSON.stringify(body),
      credentials: 'include',
      headers,
    })
      .then(() => {
        // Save the favorited template to the Redux state
        dispatch(favoriteTemplate({name: identifier}));
      })
      .catch(evite.error);
  };
